import {
  Container,
  SpaceBetween,
  ColumnLayout,
  Button,
  ExpandableSection,
  Header,
  Box,
  Form,
} from "@amzn/awsui-components-react/polaris";
import * as AssociateInformation from "../WorkersCompensation/AssociateInformation";
import * as IncidentTimeAndPlace from "../WorkersCompensation/IncidentTimeAndPlace";
import * as IncidentInformation from "../WorkersCompensation/IncidentInformation";
import * as PhysicianInformation from "../WorkersCompensation/PhysicianInformation";
import * as FileAttachments from "../WorkersCompensation/FileAttachments";
import * as Notifications from "../WorkersCompensation/Notifications";
import { FormFieldConfigType } from "src/forms/types";

import {
  ASSOCIATE_INFORMATION_CONSTANTS,
  FILE_ATTACHMENTS_CONSTANTS,
  INCIDENT_INFORMATION_CONSTANTS,
  INCIDENT_TIME_AND_PLACE_CONSTANTS,
  PHYSICIAN_INFORMATION_CONSTANTS,
} from "src/forms/constants";
import FormContent from "src/forms/FormContent";
import { STEP_NAMES } from "src/app/constants";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { RootState } from "../../redux/store";
import { setSkipToStep } from "../../components/wizard/wizardSlice";
import React from "react";
import { ReviewPageContentsProps } from "../reviewPage/ReviewPage";

const WcReviewPageContents = ({
  allFormConfigs,
  renderFieldGroup,
  renderFileList,
}: ReviewPageContentsProps) => {
  const dispatch = useAppDispatch();
  //Redux Forms state
  const { allFormStates } = useAppSelector((state: RootState) => state.forms);

  const setActiveStepIndex = (step: number) => {
    dispatch(setSkipToStep({ value: step - 1 }));
  };
  const physicianInformation_0 = allFormConfigs[
    PhysicianInformation.formName
  ][0].fields!.find((f: FormFieldConfigType) => {
    return f.name === PHYSICIAN_INFORMATION_CONSTANTS.PHYSICIAN_INFORMATION_0;
  })!;
  const physicianInformation_1 = allFormConfigs[
    PhysicianInformation.formName
  ][0].fields!.find((f: FormFieldConfigType) => {
    return f.name === PHYSICIAN_INFORMATION_CONSTANTS.PHYSICIAN_INFORMATION_1;
  })!;
  const hospitalInformation = allFormConfigs[
    PhysicianInformation.formName
  ][0].fields!.find((f: FormFieldConfigType) => {
    return f.name === PHYSICIAN_INFORMATION_CONSTANTS.HOSPITAL_INFORMATION;
  })!;

  const witnessInformation_0 = allFormConfigs[
    IncidentInformation.formName
  ][0].fields!.find((f: FormFieldConfigType) => {
    return f.name === INCIDENT_INFORMATION_CONSTANTS.WITNESS_INFORMATION_0;
  })!;
  const witnessInformation_1 = allFormConfigs[
    IncidentInformation.formName
  ][0].fields!.find((f: FormFieldConfigType) => {
    return f.name === INCIDENT_INFORMATION_CONSTANTS.WITNESS_INFORMATION_1;
  })!;

  const fileAttachmentsState =
    allFormStates[FILE_ATTACHMENTS_CONSTANTS.FORM_NAME];

  const fileAttachmentsFields =
    allFormConfigs[FILE_ATTACHMENTS_CONSTANTS.FORM_NAME][0].fields;
  return (
    <Box margin={{ bottom: "l" }}>
      <SpaceBetween size="xxl">
        <SpaceBetween size="xs">
          <Header
            variant="h3"
            headingTagOverride="h2"
            actions={
              <Button
                onClick={() =>
                  setActiveStepIndex(
                    STEP_NAMES.indexOf(
                      ASSOCIATE_INFORMATION_CONSTANTS.FORM_NAME
                    ) + 1
                  )
                }
                ariaLabel="Edit, press this button to go back to Step 1: Associate Information"
              >
                Edit
              </Button>
            }
          >
            {`Step ${
              STEP_NAMES.indexOf(ASSOCIATE_INFORMATION_CONSTANTS.FORM_NAME) + 1
            }`}
          </Header>
          <Container
            header={
              <Header variant="h2" headingTagOverride="h3">
                {AssociateInformation.formHeader}
              </Header>
            }
          >
            {renderFieldGroup(
              "",
              allFormConfigs[AssociateInformation.formName][0].fields!,
              allFormStates[AssociateInformation.formName],
              AssociateInformation.formName,
              {
                startAtField:
                  ASSOCIATE_INFORMATION_CONSTANTS.ASSOCIATE_EMPLOYEE_ID,
              }
            )}
          </Container>
        </SpaceBetween>

        <SpaceBetween size="xs">
          <Header
            variant="h3"
            headingTagOverride="h2"
            actions={
              <Button
                onClick={() =>
                  setActiveStepIndex(
                    STEP_NAMES.indexOf(
                      INCIDENT_TIME_AND_PLACE_CONSTANTS.FORM_NAME
                    ) + 1
                  )
                }
                ariaLabel="Edit, press this button to go back to Step 2: Incident Time and Place"
              >
                Edit
              </Button>
            }
          >
            {`Step ${
              STEP_NAMES.indexOf(INCIDENT_TIME_AND_PLACE_CONSTANTS.FORM_NAME) +
              1
            }`}
          </Header>

          <SpaceBetween size="l">
            <Container
              header={
                <Header variant="h2" headingTagOverride="h3">
                  {IncidentTimeAndPlace.formHeader}
                </Header>
              }
            >
              <SpaceBetween size="m">
                {renderFieldGroup(
                  "",
                  allFormConfigs[IncidentTimeAndPlace.formName][0].fields!,
                  allFormStates[IncidentTimeAndPlace.formName],
                  IncidentTimeAndPlace.formName,
                  {
                    stopBeforeField:
                      INCIDENT_TIME_AND_PLACE_CONSTANTS.INCIDENT_DATE,
                  }
                )}
                {renderFieldGroup(
                  "",
                  allFormConfigs[IncidentTimeAndPlace.formName][0].fields!,
                  allFormStates[IncidentTimeAndPlace.formName],
                  IncidentTimeAndPlace.formName,
                  {
                    startAtField:
                      INCIDENT_TIME_AND_PLACE_CONSTANTS.INCIDENT_DATE,
                  }
                )}
              </SpaceBetween>
            </Container>
          </SpaceBetween>
        </SpaceBetween>
        <SpaceBetween size="xs">
          <Header
            variant="h3"
            headingTagOverride="h2"
            actions={
              <Button
                onClick={() =>
                  setActiveStepIndex(
                    STEP_NAMES.indexOf(
                      INCIDENT_INFORMATION_CONSTANTS.FORM_NAME
                    ) + 1
                  )
                }
                ariaLabel="Edit, press this button to go back to Step 3: Incident Details"
              >
                Edit
              </Button>
            }
          >
            {`Step ${
              STEP_NAMES.indexOf(INCIDENT_INFORMATION_CONSTANTS.FORM_NAME) + 1
            }`}
          </Header>

          <Container
            header={
              <Header variant="h2" headingTagOverride="h3">
                {IncidentInformation.formHeader}
              </Header>
            }
          >
            {renderFieldGroup(
              "Primary Body Part Information",
              allFormConfigs[IncidentInformation.formName][0].fields![0]
                .fields!,
              allFormStates[IncidentInformation.formName],
              IncidentInformation.formName,
              {
                expandable: true,
                hidden:
                  allFormStates[IncidentInformation.formName][
                    INCIDENT_INFORMATION_CONSTANTS.BODY_PART_INFORMATION_0
                  ].hidden,
              }
            )}
            {renderFieldGroup(
              "Secondary Body Part Information",
              allFormConfigs[IncidentInformation.formName][0].fields![1]
                .fields!,
              allFormStates[IncidentInformation.formName],
              IncidentInformation.formName,
              {
                expandable: true,
                hidden:
                  allFormStates[IncidentInformation.formName][
                    INCIDENT_INFORMATION_CONSTANTS.BODY_PART_INFORMATION_1
                  ].hidden,
              }
            )}
            {renderFieldGroup(
              "Injury/Incident Details",
              allFormConfigs[IncidentInformation.formName][0].fields!,
              allFormStates[IncidentInformation.formName],
              IncidentInformation.formName,
              {
                expandable: true,
                startAtField: INCIDENT_INFORMATION_CONSTANTS.CAUSE_OF_INJURY,
                stopBeforeField:
                  INCIDENT_INFORMATION_CONSTANTS.QUESTIONABLE_CLAIM,
                columns: 1,
              }
            )}
            <br />
            <ExpandableSection
              headerText={"Concerns"}
              variant="default"
              defaultExpanded={true}
            >
              {renderFieldGroup(
                "",
                allFormConfigs[IncidentInformation.formName][0].fields!,
                allFormStates[IncidentInformation.formName],
                IncidentInformation.formName,
                {
                  startAtField:
                    INCIDENT_INFORMATION_CONSTANTS.QUESTIONABLE_CLAIM,
                  stopBeforeField:
                    INCIDENT_INFORMATION_CONSTANTS.WITNESS_INFORMATION_AVAILABLE,
                  columns: 1,
                }
              )}
              {renderFieldGroup(
                "Concerns",
                allFormConfigs[IncidentInformation.formName][0].fields!.find(
                  (f: FormFieldConfigType) => {
                    return (
                      f.name ===
                      INCIDENT_INFORMATION_CONSTANTS.QUESTIONABLE_CLAIM_GROUP
                    );
                  }
                )!.fields!,
                allFormStates[IncidentInformation.formName],
                IncidentInformation.formName,
                {
                  expandable: false,
                  hidden:
                    allFormStates[IncidentInformation.formName][
                      INCIDENT_INFORMATION_CONSTANTS.QUESTIONABLE_CLAIM_GROUP
                    ].hidden,
                  columns: 1,
                }
              )}
            </ExpandableSection>
            <br />
            <ExpandableSection
              headerText={"Witness Information"}
              variant="default"
              defaultExpanded={true}
            >
              {renderFieldGroup(
                "",
                allFormConfigs[IncidentInformation.formName][0].fields!,
                allFormStates[IncidentInformation.formName],
                IncidentInformation.formName,
                {
                  startAtField:
                    INCIDENT_INFORMATION_CONSTANTS.WITNESS_INFORMATION_AVAILABLE,
                  stopBeforeField:
                    INCIDENT_INFORMATION_CONSTANTS.WITNESS_INFORMATION_0,
                  columns: 1,
                }
              )}
              {renderFieldGroup(
                "Witness 1",
                witnessInformation_0.fields!,
                allFormStates[IncidentInformation.formName],
                IncidentInformation.formName,
                {
                  expandable: true,
                  hidden:
                    allFormStates[IncidentInformation.formName][
                      INCIDENT_INFORMATION_CONSTANTS.WITNESS_INFORMATION_0
                    ].hidden,
                }
              )}
              {renderFieldGroup(
                "Witness 2",
                witnessInformation_1.fields!,
                allFormStates[IncidentInformation.formName],
                IncidentInformation.formName,
                {
                  expandable: true,
                  hidden:
                    allFormStates[IncidentInformation.formName][
                      INCIDENT_INFORMATION_CONSTANTS.WITNESS_INFORMATION_1
                    ].hidden,
                }
              )}
            </ExpandableSection>
          </Container>
        </SpaceBetween>

        <SpaceBetween size="xs">
          <Header
            variant="h3"
            headingTagOverride="h2"
            actions={
              <Button
                onClick={() =>
                  setActiveStepIndex(
                    STEP_NAMES.indexOf(
                      PHYSICIAN_INFORMATION_CONSTANTS.FORM_NAME
                    ) + 1
                  )
                }
                ariaLabel="Edit, press this button to go back to Step 4: Hospital/Medical Provider Information"
              >
                Edit
              </Button>
            }
          >
            {`Step ${
              STEP_NAMES.indexOf(PHYSICIAN_INFORMATION_CONSTANTS.FORM_NAME) + 1
            }`}
          </Header>
          <Container
            header={
              <Header variant="h2" headingTagOverride="h3">
                {PhysicianInformation.formHeader}
              </Header>
            }
          >
            {renderFieldGroup(
              "",
              allFormConfigs[PhysicianInformation.formName][0].fields!,
              allFormStates[PhysicianInformation.formName],
              PhysicianInformation.formName,
              {
                stopBeforeField:
                  PHYSICIAN_INFORMATION_CONSTANTS.HOSPITAL_INFORMATION,
                columns: 1,
              }
            )}
            {renderFieldGroup(
              "Hospital Information",
              [
                ...hospitalInformation.fields!,
                ...hospitalInformation.fields!.find(
                  (f: FormFieldConfigType) => {
                    return f.name === "phoneWithExtension";
                  }
                )!.fields!,
              ],
              allFormStates[PhysicianInformation.formName],
              PhysicianInformation.formName,
              {
                expandable: true,
                hidden:
                  allFormStates[PhysicianInformation.formName][
                    PHYSICIAN_INFORMATION_CONSTANTS.HOSPITAL_INFORMATION
                  ].hidden,
              }
            )}
            <br />
            <ColumnLayout columns={1} variant="text-grid">
              {renderFieldGroup(
                "",
                allFormConfigs[PhysicianInformation.formName][0].fields!,
                allFormStates[PhysicianInformation.formName],
                PhysicianInformation.formName,
                {
                  startAtField:
                    PHYSICIAN_INFORMATION_CONSTANTS.PHYSICIAN_INFORMATION_AVAILABLE,
                  stopBeforeField:
                    PHYSICIAN_INFORMATION_CONSTANTS.PHYSICIAN_INFORMATION_0,
                  columns: 1,
                }
              )}
            </ColumnLayout>
            {renderFieldGroup(
              "Physician Information 1",
              [
                ...physicianInformation_0.fields!,
                ...physicianInformation_0.fields!.find(
                  (f: FormFieldConfigType) => {
                    return f.name === "phoneWithExtension";
                  }
                )!.fields!,
              ],
              allFormStates[PhysicianInformation.formName],
              PhysicianInformation.formName,
              {
                expandable: true,
                hidden:
                  allFormStates[PhysicianInformation.formName][
                    PHYSICIAN_INFORMATION_CONSTANTS.PHYSICIAN_INFORMATION_0
                  ].hidden,
              }
            )}
            {renderFieldGroup(
              "Physician Information 2",
              [
                ...physicianInformation_1.fields!,
                ...physicianInformation_1.fields!.find(
                  (f: FormFieldConfigType) => {
                    return f.name === "phoneWithExtension";
                  }
                )!.fields!,
              ],
              allFormStates[PhysicianInformation.formName],
              PhysicianInformation.formName,
              {
                expandable: true,
                hidden:
                  allFormStates[PhysicianInformation.formName][
                    PHYSICIAN_INFORMATION_CONSTANTS.PHYSICIAN_INFORMATION_1
                  ].hidden,
              }
            )}
          </Container>
        </SpaceBetween>

        <SpaceBetween size="xs">
          <Header
            variant="h3"
            headingTagOverride="h2"
            actions={
              <Button
                onClick={() =>
                  setActiveStepIndex(
                    STEP_NAMES.indexOf(FILE_ATTACHMENTS_CONSTANTS.FORM_NAME) + 1
                  )
                }
                ariaLabel="Edit, press this button to go back to Step 5: File Attachments"
              >
                Edit
              </Button>
            }
          >
            {`Step ${
              STEP_NAMES.indexOf(FILE_ATTACHMENTS_CONSTANTS.FORM_NAME) + 1
            }`}
          </Header>
          <Container
            header={
              <Header variant="h2" headingTagOverride="h3">
                {FileAttachments.formHeader}
              </Header>
            }
          >
            {renderFileList(fileAttachmentsState, fileAttachmentsFields)}
          </Container>
        </SpaceBetween>
        <Form>
          <FormContent
            formName={Notifications.formName}
            formConfig={Notifications.formConfig}
            formValidation={Notifications.formValidation}
            data-testid="notifications-form"
            key="notifications-form"
          />
        </Form>
      </SpaceBetween>
    </Box>
  );
};
export default WcReviewPageContents;
